
import {
  DRIVE_EDIT_DOCUMENT_ATRIBUTES_REQUEST,
  DRIVE_REPLACE_DOCUMENT,
  DRIVE_FETCH_CURRENT_DIRECTORY_REQUEST,
  DRIVE_FETCH_CURRENT_DIRECTORY_SUCCESS,
  DRIVE_INITIALIZE,
  DRIVE_SET_CURRENT_DIRECTORY,
  DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_REQUEST,
  DRIVE_ADD_TO_CURRENT_DIRECTORY,
  DRIVE_REMOVE_DOCUMENTS_REQUEST,
  DRIVE_SELECT_DOCUMENTS,
  DRIVE_REMOVE_DOCUMENT_FROM_STORE_BY_ID,
  DRIVE_SET_USED_PERCENTAGE, 
  DRIVE_SET_ENTIDADES, 
  DRIVE_SET_ENTIDADES_REQUEST,
  DRIVE_SET_GB_CONTRATADOS,
} from '../constants/drive.contants';

export const establecerDirectorioActual = ({ entidadTipoId, entidadId, tiendaId }) => ({
  type: DRIVE_SET_CURRENT_DIRECTORY,
  payload: {
    entidadTipoId, entidadId, tiendaId,
  },
})

export const setFilesToCurrentDirectory = ({ files, total}) => ({
  type: DRIVE_FETCH_CURRENT_DIRECTORY_SUCCESS,
  payload: {
    files,
    total
  },
});

export const fetchCurrentDirectory = () => ({
  type: DRIVE_FETCH_CURRENT_DIRECTORY_REQUEST
});

export const uploadDocumentToCurrentDirectory = ({ file, name, descripcion }) => ({
  type: DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_REQUEST,
  payload: {
    file, name, descripcion,
  },
});

export const addFileToCurrentDirectory = ({ file }) => ({
  type: DRIVE_ADD_TO_CURRENT_DIRECTORY,
  payload: {
    file,
  },
});

export const requestEditDocumentById = ({ id, nombre, descripcion }) => ({
  type: DRIVE_EDIT_DOCUMENT_ATRIBUTES_REQUEST,
  payload: {
    id, nombre, descripcion,
  },
});

export const reemplazarDocumento = ({ documento, id}) => ({
  type: DRIVE_REPLACE_DOCUMENT,
  payload: { documento, id },
});

export const eliminarDocumentosDB = ({ documentos }) => ({
  type: DRIVE_REMOVE_DOCUMENTS_REQUEST,
  payload: { documentos }
});

export const eliminarDocumentoFromStoreById = ({ id }) => ({
  type: DRIVE_REMOVE_DOCUMENT_FROM_STORE_BY_ID,
  payload: { id }
});

export const seleccionarDocumentos = ({ documentos, selectedRowKeys }) => ({
  type: DRIVE_SELECT_DOCUMENTS,
  payload: { documentos, selectedRowKeys }
});

export const establecerPorcentajeUsoCarpetaActual = ({ porcentaje }) => ({
  type: DRIVE_SET_USED_PERCENTAGE,
  payload: { porcentaje },
});

export const establecerTotalContratado = ({ total }) => ({
  type: DRIVE_SET_GB_CONTRATADOS,
  payload: { total },
});

export const cargarEntidadesRequest = () => ({
  type: DRIVE_SET_ENTIDADES_REQUEST,
});

export const establecerEntidades = ({ entidades }) => ({
  type: DRIVE_SET_ENTIDADES,
  payload: { entidades },
});


export const initialize = () => ({
  type: DRIVE_INITIALIZE
});
